export type PurchaseStatus = "Submitted" | "Re-Submitted" | "Approved" | "Rejected";

export type PurchaseLineItem = {
    vendorId: string | number;
    vendorName: string;
    description: string;
    unitPrice: string;
    quantity: string;
    lineTotal: string;
};

export type Purchase = {
    id: number | null;
    pdfId: string;
    poNumber: string;
    poDate: string;
    poType: "pr" | "re";
    category: string;
    projectId: number | null;
    projectName: string;
    requesterId: string;
    requesterName: string;
    requester: {
        label: string;
        value: string;
    } | null;
    approverId: string;
    approverName: string;
    approver: {
        label: string;
        value: string;
    } | null;
    department: string;
    paymentMethod: string;
    last4: string;
    billable: "yes" | "no";
    includedInProposal: "yes" | "no";
    clientInvoiceNumber: string;
    notes: string;
    subtotal: string;
    tax: string;
    discount: string;
    total: string;
    data: PurchaseLineItem[];
    status: PurchaseStatus;
    paid: "yes" | "no";
    billed: "yes" | "no";
    approverNotes: string;
    approvalTime: string;
    submitterId: string;
    submitterName: string;
    submitTime: string;
    notifiedAt: string;
    notifiedBy: string;
    notifierName: string;
    creatorId: string;
    creatorName: string;
    createdAt: string;
    updaterId: string;
    updaterName: string;
    updatedAt: string;
    void: "yes" | "no";
    voidReason: string;
    validateReason: string;
    quoteFileId: string;
    receiptFileId: string;
    quoteUrl: string;
    receiptUrl: string;
};

export const purchaseCategories = [
    "Project Expense",
    "Outside Service Expense",
    "Office Supply",
    "Vehicle Maintenance",
    "Equipment Expense",
    "Equipment Maintenance",
    "Yard Material",
    "Vehicle Rental",
    "Traffic Control Related",
    "Subscription",
    "In-House Training",
    "QA/QC",
    "Marketing",
    "Safety",
    "Accommodation",
    "Saw Cutting",
    "Scanning & Coring Materials",
];

export const defaultPurchaseLineItem: PurchaseLineItem = {
    vendorId: "",
    vendorName: "",
    description: "",
    unitPrice: "",
    quantity: "1",
    lineTotal: "",
};

export const defaultPurchase: Purchase = {
    id: null,
    pdfId: "",
    poNumber: "",
    poDate: "",
    poType: "pr",
    category: "",
    projectId: null,
    projectName: "",
    requesterId: "",
    requesterName: "",
    requester: null,
    approverId: "",
    approverName: "",
    approver: null,
    department: "",
    paymentMethod: "",
    last4: "",
    billable: "no",
    includedInProposal: "no",
    clientInvoiceNumber: "",
    notes: "",
    subtotal: "0.00",
    tax: "0.00",
    discount: "0.00",
    total: "0.00",
    data: [{ ...defaultPurchaseLineItem }],
    status: "Submitted",
    paid: "no",
    billed: "no",
    approverNotes: "",
    approvalTime: "",
    submitterId: "",
    submitterName: "",
    submitTime: "",
    notifiedAt: "",
    notifiedBy: "",
    notifierName: "",
    creatorId: "",
    creatorName: "",
    createdAt: "",
    updaterId: "",
    updaterName: "",
    updatedAt: "",
    void: "no",
    voidReason: "",
    validateReason: "",
    quoteFileId: "",
    receiptFileId: "",
    quoteUrl: "",
    receiptUrl: "",
};
